import { render, staticRenderFns } from "./scrap.vue?vue&type=template&id=f3d5caa8&"
import script from "./scrap.vue?vue&type=script&lang=js&"
export * from "./scrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports